(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apron-feeder-product"] && !Shopify.designMode) return;
  try {
    
(function(){function translateGallery(){document.querySelectorAll('[data-naf-gallery]').forEach(function(g){var p=g.querySelector('.nfb-gallery-prev'),n=g.querySelector('.nfb-gallery-next');if(p)p.setAttribute('aria-label',g.dataset.previousLabel);if(n)n.setAttribute('aria-label',g.dataset.nextLabel);});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',translateGallery);}else{translateGallery();}})();

  } catch(e) { console.error(e); }
})();
})();
